import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromptService {

constructor(private http:HttpClient) { }

getPrompts() {
  return this.http.get<any[]>(`${environment.apiUrl}prompts`);
}
update(model:any,id:any) {
  return this.http.put<any>(`${environment.apiUrl}prompts/${id}`,model);
}
}
